/******************************************************************************************
 *	Settings Constant
 ******************************************************************************************/
(function() {
  

  angular.module('rcServices.settings', []).constant('Settings', {
    //Pagination: number of items per page
    itemsPerPage: {
      default: 20,
      seatHistory: 5,
      teamMembersModal: 10
    },

    //Max number of days that a customer's renewal window can be extended by, at one time
    MAX_RENEWAL_EXTENSION_DAYS: 30,

    //Default region code
    //Required to localize its label
    DEFAULT_REGION_CODE: '00',

    //Matches ASCII printable characters (character code 32-127, HEX 20-7F)
    ASCII_REGEXP: /^[\x20-\x7F]*$/,


    // This regex was provided by IMS and matches their email validation.
    ADOBEID_EMAIL_REGEXP: /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+(?:[a-zA-Z]*)\b$/,
    ADOBEID_MAX_LENGTH: 60,

    //Default date format
    DEFAULT_DATE_FORMAT: 'longDate',

    //Default time zone name
    DEFAULT_TIMEZONE: 'PT',

    //JIL Notifications API delay settings
    //Delay between JIL API response and Angular Service promise being settled.
    //This delay exists to give enough time for data to be refreshed and replaced in cache for an average-sized reseller.
    TIMEOUT_AFTER_CUSTOMER_REFRESH: 10000,

    //Cannot send another CUSTOMER_CHANGED notification until this timeout expired.
    CUSTOMER_REFRESH_NOTIFICATION_LOCK: 600000
  });
})();
